import { mergeStyles } from '@workday/canvas-kit-react/layout';
import { OverflowTooltip } from '@workday/canvas-kit-react/tooltip';
import { themedTooltipPopperBodyStyles } from './tooltipSurfaceStyles';

export const ThemedOverflowTooltip = (props: React.ComponentProps<typeof OverflowTooltip>) => (
  <OverflowTooltip {...mergeStyles(props, [themedTooltipPopperBodyStyles])} />
);
